<p-panel
    [class.clipContent]="clipContent()"
    [class.autoContent]="!clipContent()"
    [class.margin]="addPanelMargin()"
    [class.padding]="addPanelPadding()"
    [showHeader]="headerTemplate"
>

    @if (headerTemplate) {
        <ng-template #header>
            <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
        </ng-template>
    }

    @if (iconsTemplate) {
        <ng-template #icons>
            <ng-container *ngTemplateOutlet="iconsTemplate"></ng-container>
        </ng-template>
    }

    <ng-content></ng-content>

</p-panel>
